import './css/VideoThumbnailTicks.css';

interface VideoThumbnailTicksProps {
    fullDurationPixelWidth: number;
    timelineOffset: number;
    ticks: Array<{ t: number; left: number; label: string }>;
    minorTicks: Array<{ t: number; left: number }>;
}

export const VideoThumbnailTicks: React.FC<VideoThumbnailTicksProps> = ({ fullDurationPixelWidth, timelineOffset, ticks, minorTicks }) => {
    return (
        <div
            className="video-time-indicators"
            style={{
                width: `${fullDurationPixelWidth}px`,
                transform: `translateX(${-timelineOffset}px)`
            }}>
            {minorTicks.map((tick, i) => (
                <div
                    key={`m-${i}`}
                    className="minor-tick-mark"
                    style={{ left: `${tick.left}px` }}
                />
            ))}
            {ticks.map((tick, i) => (
                <div key={i} className="tick-container" style={{ left: `${tick.left}px` }}>
                    <div className="tick-mark" />
                    <div className="tick-label">{tick.label}</div>
                </div>
            ))}
        </div>
    );
};
